import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { tagAmberTextColor } from "../../../config/ColorObj";
import { IconActive, IconClosed, IconCollection, IconProducts, IconRupee, IconUnits } from "../components/SvgIcons";
import {
    COLORS,
    statusBadge,
    challanCard,
    tag,
} from "../styles/ChallanStyles";

// Maps tag index → icon component
export const TAG_ICONS = [
    () => <IconUnits />,
    () => <IconProducts />,
    (label = "") =>
        label.toLowerCase().includes("closed") ? (
            <IconClosed />
        ) : (
            <IconRupee color={tagAmberTextColor} />
        ),
    () => <IconCollection />,
];

export const STATUS_CONFIG = {
    closed: { label: "Closed", dot: COLORS.activeDot },
    active: { label: "Active", dot: COLORS.closedDot },
    overdue: { label: "Pending", dot: COLORS.overdueDot },
};

export const StatusBadge = ({ status }) => (
    <TypographyCompo style={statusBadge(status)}>
        {STATUS_CONFIG[status]?.label || status}
    </TypographyCompo>
);

// ── Small reusable UI pieces ───────────────────────────────────────────────────

// IMPROVED: Tag uses a wrapping TypographyCompo so it can flex-grow within its tagRow cell.
// The outer TypographyCompo fills the flex cell (flex: 1); the inner TypographyCompo is the visible pill.
export const Tag = ({ label, colorKey, icon }) => (
    <TypographyCompo style={{ display: "flex", flex: 1, minWidth: 0 }}>
        <TypographyCompo style={tag(colorKey)}>
            {icon && <TypographyCompo style={challanCard.tagIcon}>{icon}</TypographyCompo>}
            {label}
        </TypographyCompo>
    </TypographyCompo>
);